var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('h3',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("The content will be available soon.")])])}
var staticRenderFns = []

export { render, staticRenderFns }